export enum Flipper {
  onboarding = 'onboarding',
  launchOnboarding = 'rt_partner_onboarding',
}
